/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Two modes:
 *  - Convenience mode (recommended): set `targetEnv` ("prod" or "dev").
 *    The server uses stored EnvCredentials (POST /admin-tools/env-credentials)
 *    to fetch a fresh Bearer token automatically.
 *  - Manual mode: set `targetApiBaseUrl` + `targetToken` directly. Useful
 *    for one-off pushes against an environment that's not configured.
 * @export
 * @interface TemplatePushToEnvRequest
 */
export interface TemplatePushToEnvRequest {
    /**
     * Stored target env. If set, targetApiBaseUrl + targetToken are ignored.
     * @type {string}
     * @memberof TemplatePushToEnvRequest
     */
    targetEnv?: TemplatePushToEnvRequestTargetEnvEnum;
    /**
     * Base URL of the target backend (manual mode).
     * @type {string}
     * @memberof TemplatePushToEnvRequest
     */
    targetApiBaseUrl?: string;
    /**
     * Fresh Bearer token (manual mode, without "Bearer " prefix).
     * @type {string}
     * @memberof TemplatePushToEnvRequest
     */
    targetToken?: string;
    /**
     * If true and a template with the same templateCanonicalId exists on the target, it will be overwritten.
     * @type {boolean}
     * @memberof TemplatePushToEnvRequest
     */
    overwrite?: boolean;
}


/**
 * @export
 */
export const TemplatePushToEnvRequestTargetEnvEnum = {
    Prod: 'prod',
    Dev: 'dev'
} as const;
export type TemplatePushToEnvRequestTargetEnvEnum = typeof TemplatePushToEnvRequestTargetEnvEnum[keyof typeof TemplatePushToEnvRequestTargetEnvEnum];


/**
 * Check if a given object implements the TemplatePushToEnvRequest interface.
 */
export function instanceOfTemplatePushToEnvRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TemplatePushToEnvRequestFromJSON(json: any): TemplatePushToEnvRequest {
    return TemplatePushToEnvRequestFromJSONTyped(json, false);
}

export function TemplatePushToEnvRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplatePushToEnvRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetEnv': !exists(json, 'targetEnv') ? undefined : json['targetEnv'],
        'targetApiBaseUrl': !exists(json, 'targetApiBaseUrl') ? undefined : json['targetApiBaseUrl'],
        'targetToken': !exists(json, 'targetToken') ? undefined : json['targetToken'],
        'overwrite': !exists(json, 'overwrite') ? undefined : json['overwrite'],
    };
}

export function TemplatePushToEnvRequestToJSON(value?: TemplatePushToEnvRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'targetEnv': value.targetEnv,
        'targetApiBaseUrl': value.targetApiBaseUrl,
        'targetToken': value.targetToken,
        'overwrite': value.overwrite,
    };
}

